import { render, staticRenderFns } from "./TestimoniosContainer.vue?vue&type=template&id=069e6754&scoped=true&"
import script from "./TestimoniosContainer.vue?vue&type=script&lang=js&"
export * from "./TestimoniosContainer.vue?vue&type=script&lang=js&"
import style0 from "./TestimoniosContainer.vue?vue&type=style&index=0&id=069e6754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e6754",
  null
  
)

export default component.exports